import { Directive, Input, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[appAlfaNumeric]',
  host: {
    '(input)': 'onInputChange($event)'
  }
})
export class AlfaNumericDirective {

  // tslint:disable-next-line:no-input-rename
  @Input('limite') limite: number;
  @Output() ngModelChange: EventEmitter<any> = new EventEmitter();
  value: any;
  transformada: string;
  expresionValidadora = new RegExp('^([a-zA-z0-9])*$');
  expresionTransformada = /[^a-zA-z0-9]*$/g;
  constructor() { }

  onInputChange($event) {
    this.transformada = $event.target.value;
    this.aplicarExpresionSoloNumeros();
    this.validarLimiteTransformada();
    this.actualizarModelo($event);
  }


  aplicarExpresionSoloNumeros() {
    if (this.expresionValidadora.test(this.transformada) === false) {
      this.transformada = this.transformada.replace(this.expresionTransformada, '');
    }

  }


  validarLimiteTransformada() {
    if (this.limite !== undefined && this.limite !== null && this.limite > 0) {
      if (this.transformada.length > this.limite) {
        this.transformada = this.transformada.substring(0, this.limite);
      }
    }
  }

  actualizarModelo($event: any) {
    if (this.transformada !== $event.target.value) {
      $event.target.value = this.transformada;
      this.ngModelChange.emit(this.transformada);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/directives/alfa-numeric.directive.ts